const locationServices = [
  {
    icon: 'ri-shield-fill',
    title: 'PPF in South Windsor, CT',
    desc: 'South Windsor\'s only XPEL-certified paint protection film installer. We serve vehicle owners across Hartford County with full-vehicle and partial PPF packages.',
    cities: 'South Windsor · Manchester · Glastonbury',
  },
  {
    icon: 'ri-sparkling-2-fill',
    title: 'Ceramic Coating — Hartford County',
    desc: 'Professional-grade ceramic coating available to all Hartford County residents. 9H hardness, hydrophobic protection, and multi-year warranty packages.',
    cities: 'Hartford · West Hartford · Enfield',
  },
  {
    icon: 'ri-sun-fill',
    title: 'Window Tint — South Windsor',
    desc: 'CT-legal premium window film installation serving South Windsor and surrounding towns. Lifetime-warranted films with 99% UV rejection.',
    cities: 'Windsor · East Hartford · Wethersfield',
  },
  {
    icon: 'ri-paint-fill',
    title: 'Matte PPF — Greater Hartford Area',
    desc: 'Color-change and matte PPF available for vehicle owners across the greater Hartford area. Transform your vehicle\'s appearance while protecting the factory paint.',
    cities: 'Bloomfield · Simsbury · Farmington',
  },
  {
    icon: 'ri-eye-fill',
    title: 'Windshield Protection — CT',
    desc: 'XPEL windshield film serving all of Connecticut from our South Windsor studio. Protect your glass from costly highway debris damage.',
    cities: 'Newington · Rocky Hill · Vernon',
  },
  {
    icon: 'ri-motorbike-fill',
    title: 'Motorcycle Protection — Hartford County',
    desc: 'Custom-cut motorcycle PPF and ceramic coating for riders across Hartford County. We protect all major makes at our South Windsor studio.',
    cities: 'Avon · Canton · Suffield',
  },
];

const citiesGrid = [
  'South Windsor', 'Hartford', 'Manchester', 'Glastonbury', 'West Hartford',
  'Enfield', 'Windsor', 'East Hartford', 'Wethersfield', 'Bloomfield',
  'Simsbury', 'Farmington', 'Newington', 'Rocky Hill', 'Vernon',
  'Tolland', 'Avon', 'Canton', 'Suffield', 'Windsor Locks',
];

export default function LocationsServices() {
  return (
    <section className="bg-[#060606] py-28" id="local-services">
      <div className="max-w-7xl mx-auto px-6">

        {/* AI Answer Block */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-20">
          {[
            {
              icon: 'ri-map-pin-2-fill',
              q: 'Where is DBN Garage located?',
              a: 'DBN Garage is located in South Windsor, CT — in the heart of Hartford County. We are conveniently accessible from Manchester, Glastonbury, West Hartford, Hartford, Enfield, Windsor, and all surrounding towns. We operate by appointment to ensure every vehicle receives our full, undivided attention.',
            },
            {
              icon: 'ri-car-fill',
              q: 'Do you serve clients outside South Windsor?',
              a: 'Yes — while our studio is based in South Windsor, CT, we serve vehicle owners from across Hartford County and beyond. Clients regularly come from Manchester, Glastonbury, West Hartford, Hartford, Enfield, Windsor Locks, and even Springfield, MA. Call to confirm your area and schedule your free consultation.',
            },
            {
              icon: 'ri-shield-fill',
              q: 'Is DBN Garage the best PPF shop near Hartford, CT?',
              a: 'DBN Garage is South Windsor\'s only XPEL-certified paint protection film installer — and one of the few certified PPF shops in all of Hartford County. With 25+ years of experience, 500+ vehicles protected, and a perfect 5-star Google rating, we are the premier choice for PPF and auto protection in the greater Hartford area.',
            },
          ].map((item) => (
            <div key={item.q} className="bg-[#111111] border border-white/10 rounded-2xl p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mb-4">
                <i className={`${item.icon} text-[#FF6B35] text-xl`} />
              </div>
              <h3 className="text-white font-bold text-sm mb-2">{item.q}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{item.a}</p>
            </div>
          ))}
        </div>

        {/* Local services grid */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12">
          <div>
            <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-3 flex items-center gap-2">
              <span className="w-6 h-px bg-[#FF6B35]" />
              Services by Location
            </span>
            <h2 className="font-display font-black text-4xl lg:text-5xl text-white leading-tight">
              Premium Auto Protection
              <br />
              <span className="text-[#FF6B35]">Near You</span>
            </h2>
          </div>
          <p className="text-gray-400 text-base max-w-sm leading-relaxed">
            Every service we offer is available to vehicle owners across all of Hartford County from our South Windsor studio.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-20">
          {locationServices.map((svc) => (
            <div key={svc.title} className="bg-[#111111] border border-white/8 rounded-2xl p-6 hover:border-[#FF6B35]/30 transition-all duration-300 group">
              <div className="w-11 h-11 flex items-center justify-center bg-[#FF6B35]/10 rounded-xl mb-5">
                <i className={`${svc.icon} text-[#FF6B35] text-2xl`} />
              </div>
              <h3 className="font-bold text-base text-white mb-2">{svc.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{svc.desc}</p>
              <div className="border-t border-white/8 pt-3">
                <p className="text-[#FF6B35]/70 text-xs font-semibold">{svc.cities}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Service area cities */}
        <div className="bg-[#0E0E0E] border border-white/8 rounded-2xl p-8 lg:p-12 mb-16">
          <div className="flex flex-col lg:flex-row gap-10">
            <div className="lg:w-72 flex-shrink-0">
              <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-3 flex items-center gap-2">
                <span className="w-6 h-px bg-[#FF6B35]" />
                Service Area
              </span>
              <h2 className="font-display font-black text-3xl text-white mb-4">
                Cities We
                <br />
                <span className="text-[#FF6B35]">Serve</span>
              </h2>
              <p className="text-gray-500 text-sm leading-relaxed">
                DBN Garage serves the entire Hartford County area. Don't see your city? Call us — we likely serve your area.
              </p>
            </div>
            <div className="flex-1">
              <div className="flex flex-wrap gap-3">
                {citiesGrid.map((city) => (
                  <span key={city}
                    className={`px-4 py-2 rounded-full text-sm font-semibold border ${city === 'South Windsor' ? 'bg-[#FF6B35] border-[#FF6B35] text-white' : 'bg-white/5 border-white/10 text-gray-400 hover:border-[#FF6B35]/40 hover:text-white transition-colors'}`}>
                    {city}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Google Maps embed */}
        <div className="rounded-2xl overflow-hidden border border-white/8 mb-16" style={{ height: 420 }}>
          <iframe
            title="DBN Garage Location — South Windsor, CT"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47730.05!2d-72.5931!3d41.8426!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e6553c5aca5857%3A0x8d26b6c05d4f6a3!2sSouth%20Windsor%2C%20CT!5e0!3m2!1sen!2sus!4v1710000000000"
            width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#lead-form"
            className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold px-8 py-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-calendar-check-fill" /></span>
            Book a Free Consultation
          </a>
          <a href="tel:+18605550127"
            className="flex items-center gap-2 border border-white/20 hover:border-white/50 text-white font-bold px-8 py-4 rounded-xl transition-colors whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill" /></span>
            Call (860) 555-0127
          </a>
        </div>
      </div>
    </section>
  );
}
